module.exports = __webpack_public_path__ + "img/w-explore-shop.3bfacec4.svg";